import { PhoneVerificationWizard } from '@identity/presentation/components/specific';
import { IdentityFlowProvider } from '@identity/presentation/context';

/**
 * The wait for the link that verifies a phone changed from Mi perfil.
 *
 * It checks nothing before rendering: its credential is the Parrot session, and the private route
 * already redirects to the login when there is none.
 */
export const PhoneVerificationPage = () => (
  <IdentityFlowProvider flow="profile">
    <PhoneVerificationWizard />
  </IdentityFlowProvider>
);
